import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20and%20hopeful%20illustration%20of%20a%20figure%20reaching%20towards%20warm%20golden%20light%2C%20Chinese%20ink%20painting%20style%20with%20modern%20digital%20art%20elements%2C%20atmospheric%20and%20emotional%2C%20soft%20gradient%20background&width=1600&height=600&seq=cta-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/85 to-background-950/60"></div>
      </div>

      <div className="relative z-10 max-w-[1280px] mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-4">
          准备好了吗？开启你的挣扎之旅
        </h2>
        <p className="text-background-200 text-sm md:text-base max-w-[600px] mx-auto mb-8 leading-relaxed">
          在命运的十字路口，每一个选择都至关重要。现在，轮到你来书写亚当君的故事了。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/all"
            className="px-8 py-3 rounded-md bg-accent-500 text-background-950 font-bold text-sm hover:bg-accent-400 transition-all duration-300 whitespace-nowrap"
          >
            开始探索
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-md bg-background-50/10 text-background-50 border border-background-50/30 font-medium text-sm hover:bg-background-50/20 transition-all duration-300 whitespace-nowrap"
          >
            了解制作团队
          </Link>
        </div>
      </div>
    </section>
  );
}